import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import ScrollReveal from "../../utils/ScrollReveal";
import Seo from "../../seo/Seo";

// import sections
import OurStoryTopImg from "../../components/sections/our-story/OurStoryTopImg";
import WhoWeAre from "../../components/sections/our-story/WhoWeAre";
import HowWeWork from "../../components/sections/our-story/HowWeWork";
import WhatWeValue from "../../components/sections/our-story/WhatWeValue";

const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

const OurStory = () => {
  const childRef = useRef();
  let location = useLocation();
  const page = location.pathname;

  useEffect(() => {
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
  }, [location, page]);

  return (
    <>
      <Seo
        title="Our Story"
        description="Who we are, how we work, and what we value at Trade Square — a Bangkok-based technology consulting and software delivery team."
        canonical="/our-story"
      />
    <ScrollReveal
      ref={childRef}
      children={() => (
        <React.Fragment>
          {/* {page} */}
          <div className="bg-top" />
          <OurStoryTopImg id="OurStoryTopImg" />
          <WhoWeAre id="WhoWeAre" topDivider />
          <HowWeWork id="HowWeWork" topDivider />
          <WhatWeValue invertMobile topDivider id="WhatWeValue" />
          <div className="bg-bottom" />
        </React.Fragment>
      )}
    />
    </>
  );
};

export default OurStory;
